<template>
  <div>
    <el-form class="serach-form" :inline="true" :model="filters" size="small">
      <el-form-item class="select_btn">
        <el-select
          class="select_btn_style"
          v-model="filters.groupId"
          placeholder="分组名称"
        >
          <el-option
            v-for="(item, i) in groupNameList"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="select_btn">
        <el-select
          class="select_btn_style"
          v-model="filters.deptIds"
          placeholder="工作单位(多选)"
          multiple
        >
          <el-option
            v-for="(item, i) in workUnitData"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="select_btn_170">
        <el-select
          class="select_btn_style"
          v-model="filters.lines"
          placeholder="单位所属条线(多选)"
          multiple
        >
          <el-option
            v-for="(item, i) in lineData"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="select_btn">
        <el-select
          class="select_btn_style"
          v-model="filters.positionTag"
          placeholder="职务层次(多选)"
          multiple
        >
          <el-option
            v-for="(item, i) in jobData"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="select_btn">
        <el-select
          class="select_btn_style"
          v-model="filters.positionLevel"
          placeholder="职级(多选)"
          multiple
        >
          <el-option
            v-for="(item, i) in jobLevelData"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="select_btn">
        <el-select
          class="select_btn_style"
          v-model="filters.sex"
          placeholder="性别"
        >
          <el-option
            v-for="(item, i) in genderData"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="select_btn">
        <el-select
          class="select_btn_style"
          v-model="filters.politics"
          placeholder="政治面貌(多选)"
          multiple
        >
          <el-option
            v-for="(item, i) in policyData"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="select_btn">
        <el-select
          class="select_btn_style right-10"
          v-model="filters.education"
          placeholder="学历(多选)"
          multiple
        >
          <el-option
            v-for="(item, i) in degreeData"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-show="collapseFlag">
        <butn btntype="primary" title="查询" @click="initData"></butn>
        <butn title="重置" @click="resetData" class="czButn"></butn>
        <butn
          title="展开"
          @click="changeCollapse"
          class="czButn"
          iconName="el-icon-arrow-down"
        ></butn>
      </el-form-item>
    </el-form>
    <el-form
      class="serach-form"
      :inline="true"
      :model="filters"
      size="small"
      v-show="!collapseFlag"
    >
      <el-form-item
        class="select_btn_140 right-10"
        v-if="isParty == 1 && groupSourceType == 1"
      >
        <el-select
          class="select_btn_style"
          v-model="filters.groupPushStatus"
          placeholder="党校同步状态"
        >
          <el-option
            v-for="(item, i) in syncStatusData.slice(
              0,
              syncStatusData.length - 1
            )"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="出生年月：">
        <el-date-picker
          v-model="filters.month"
          type="monthrange"
          range-separator="至"
          start-placeholder="开始月份"
          end-placeholder="结束月份"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item class="m-l-14">
        <el-input
          size="small"
          v-model.trim="filters.name"
          placeholder="姓名/房间号"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <butn btntype="primary" title="查询" @click="initData"></butn>
        <butn title="重置" @click="resetData" class="czButn"></butn>
        <butn
          title="收起"
          @click="changeCollapse"
          class="czButn"
          iconName="el-icon-arrow-up"
        ></butn>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import butn from "@/components/button/index";
import { getEnums } from "@/utils/common";
import { queryCondition } from "@/api/groupManage";

export default {
  components: { butn },
  props: {
    groupNameList: {
      type: Array,
      default: () => [],
    },
    classId: {
      type: String,
      default: () => "",
    },
    isParty: {
      type: String,
      default: () => "0",
    },
    groupSourceType: {
      type: Number,
      default: () => 1,
    },
  },
  data() {
    return {
      filters: {
        groupId: null,
      },
      workUnitData: [],
      jobData: [],
      jobLevelData: [],
      genderData: [],
      policyData: [],
      degreeData: [],
      collapseFlag: true,
      syncStatusData: [],
      lineData: []
    };
  },
  created() {
    // getEnum("USER_SEX", this, "genderData");
    getEnums(
      ["USER_SEX", "CLASS_PUSH_STATUS"],
      this,
      ["genderData", "syncStatusData"],
      [true, true]
    );
    this.getCondition([0, 1, 2, 3, 4, 5]);
  },
  methods: {
    changeCollapse() {
      this.collapseFlag = !this.collapseFlag;
    },
    getCondition(conditionTypes) {
      queryCondition({ classId: this.classId, conditionTypes }).then(
        ({ code, data }) => {
          if (code !== 0) return;
          let { dept, education, politics, positionLevel, positionTag, line } = data;
          this.workUnitData = dept;
          this.jobData = positionTag;
          this.jobLevelData = positionLevel;
          this.policyData = politics;
          this.degreeData = education;
          this.lineData = line;
        }
      );
    },
    initData() {
      let params = {};
      Object.keys(this.filters).forEach((x) => {
        if (Array.isArray(this.filters[x])) {
          params[x] = this.filters[x].join(",");
        } else {
          params[x] = this.filters[x];
        }
      });
      if (Array.isArray(this.filters.month) && this.filters.month.length > 1) {
        params["startDate"] = this.filters.month[0];
        params["endDate"] = this.filters.month[1];
      }

      this.$emit("search", { ...params });
    },
    resetData() {
      this.filters = {};
      this.$emit("reload");
    },
  },
};
</script>

<style lang="scss" scoped>
.serach-form {
  text-align: right;
}
/deep/ .el-select__tags-text {
  display: inline-block;
  max-width: 85px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/deep/ .el-tag.el-tag--info .el-tag__close {
  display: inline-block;
  margin-top: -12px;
}
.right-10 {
  margin-right: 10px !important;
}
/deep/ .select_btn {
  width: 135px !important;
}
</style>
